import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import {videoModal} from './modals';

const FWMedia = () => {

    let media = document.querySelectorAll('.fw-media--video');
    Vue.use(VModal);

    let mediaConstructor = (id) => {
        Vue.component('fw-media-template', {
            data: function() {
                return {
                    videoUrl: '',
                    videoName: null
                }
            },
            methods: {
                launchVideo() {
                    // console.log("clicked");
                    this.$modal.show(
                        videoModal.template(this.videoUrl, this.videoName),
                        videoModal.name,
                        videoModal.options
                    )
                }
            },
            mounted() {
                this.videoUrl = this.$el.querySelector('.fw-media__play-button').dataset.videoUrl;
                this.videoName = this.$refs.name ? this.$refs.name.innerHTML : null;
            }
        });
    
        new Vue({
            el: `.fw-media-video-${id}`,
        }).$mount(`.fw-media-video-${id}`, true);
    }

    if (media.length > 0) {
        media.forEach((item, index) => {
            item.classList.add(`fw-media-video-${index}`);
            mediaConstructor(index);
        })
    }
}

export default FWMedia;